__turbopack_context__.v({
  "colorBlue": "SolutionItem-module-scss-module__9xNgZW__colorBlue",
  "colorGreen": "SolutionItem-module-scss-module__9xNgZW__colorGreen",
  "colorOrange": "SolutionItem-module-scss-module__9xNgZW__colorOrange",
  "colorPink": "SolutionItem-module-scss-module__9xNgZW__colorPink",
  "featureItem": "SolutionItem-module-scss-module__9xNgZW__featureItem",
  "featuresList": "SolutionItem-module-scss-module__9xNgZW__featuresList",
  "image": "SolutionItem-module-scss-module__9xNgZW__image",
  "imageContainer": "SolutionItem-module-scss-module__9xNgZW__imageContainer",
  "solutionItem": "SolutionItem-module-scss-module__9xNgZW__solutionItem",
  "visible": "SolutionItem-module-scss-module__9xNgZW__visible",
});
